import { TOOLS } from "const";
import { sp_LoadUserConfig } from "types";
import type { AppUpdateCheckResult } from "helpers/utils";

export enum SettingsActionTypes {
  API_RESPONSE_SUCCESS = "@@settings/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@settings/API_RESPONSE_ERROR",

  GET_USER_SETTINGS = "@@settings/GET_USER_SETTINGS",
  UPDATE_USER_SETTINGS = "@@settings/UPDATE_USER_SETTINGS",

  LOAD_THIRD_API_URL = "@@settings/LOAD_THIRD_API_URL",
  CHECK_APP_UPDATE = "@@settings/CHECK_APP_UPDATE",
  SET_APP_UPDATE_INFO = "@@settings/SET_APP_UPDATE_INFO",

  UC_LOAD_USER_CONFIG = "@@settings/UC_LOAD_USE_CONFIG",
  UC_SET_CONFIG_VALUE = "@@settings/UC_SET_CONFIG_VALUE",

  SET_ACTIVE_TOOL = "@@settings/SET_ACTIVE_TOOL",

  SET_ORG_DDL_VALUE_FOR_PERM = "@@settings/SET_ORG_DDL_VALUE_FOR_PERM",
}

export interface SettingsState {
  settings: object;
  orgDllValueForPerm: any;
  activeTool: TOOLS | null;
  userConfig: sp_LoadUserConfig;
  ucLoadUserConfigLoading: boolean;
  appUpdateInfo: (AppUpdateCheckResult & { checkedAt?: string }) | null;
}
